import type { LayoutProps } from 'Lib/LayoutProps.type';

/** This component is currently only used for /signout page */
const SignoutLayout = ({ children }: LayoutProps) => (
    <div id="wrapper" className="auth-page">
        <div id="mask" />
        <div id="container">
            <div className="container">
                <div id="content">{children}</div>
            </div>
        </div>
    </div>
);

export default SignoutLayout;
